import React, { useReducer } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';

import './App.scss';
import { AnimatedSwitch } from 'react-router-transition';

import Input from 'components/pages/Input';
import Conf from 'components/pages/Conf';
import Thanks from 'components/pages/Thanks';
import AddInput from 'components/pages/AddInput';
import AddConf from 'components/pages/AddConf';
import AddThanks from 'components/pages/AddThanks';

import {
  INPUT_URL,
  CONF_URL,
  THANKS_URL,
  ADD_INPUT_URL,
  ADD_CONF_URL,
  ADD_THANKS_URL,
  FIRST_URL,
  debugInitialState,
} from 'utils/constant';

import AppContext from 'fluxes/context';
import AppReducer from 'fluxes/reducer';

const App = () => {

  const initialState = {
    /* Input */
    workCategory: '',
    workCategorySub: [],
    workCategoryOtherDetail: '',
    workDetailText: '',
    employmentPlacementDispatching: false,
    companyNameText: '',
    chargePersonNameText: '',
    tel: '',
    email: '',
    address: '',
    ekiCd: '',
    ekiName: '',
    
    receiptID: '',
    clickID: '',
    mediaID: '',

    /* Add-Input, Add-Conf */
    desiredStartDateKubun: '',
    desiredStartDate: '',
    hourSalaryMin: '',
    hourSalaryMax: '',
    timeSavingAva: '',
    overtimeHoursMin: '',
    overtimeHoursMax: '',
    workInfo: [],
    workInfoContent: [],
    strWorkInfo: '',
    skillLevel: '',
    suggestHourSalary: '',
    skillLevelExcel: '',
    skillLevelPowerpoint: '',
    bgdOfRecruitment: '',
    workEnvi: [],
    strWorkEnvi: '',
    strOtherSkill:'',
    strWorkPeriod:'',
    strDayOfTheWeek:'',
    strWorkTime:'',
    workStyle: '',
    overTime: '',
    startTime: '',
    endTime: '',
    workPeriod: '',
    useCar: '',
    holidayWork: '',
    remoteWork: '',
    remoteWorkCount:'',
    welfare: [],
    smokeEnvi: '',
    otherComment:'',
    workInfoContentCmnt: '',
    skillOtherCmnt: '',
    bgdOfRecruitmentCmnt: '',
    workStyleCmnt: '',
    startTimeCmnt: '',
    endTimeCmnt: '',
    workPeriodCmnt: '',

    isModify: false,
    validMap: {
      [INPUT_URL]: false,
      [CONF_URL]: false,
      [THANKS_URL]: false,
      [ADD_INPUT_URL]: false,
      [ADD_CONF_URL]: false,
      [ADD_THANKS_URL]: false,
    },
    isRegistered: false,
    isAddRegistered: false,
    isRegisteredLeaveWithoutOrder: false,
    olodTarget: false,
  };
  
  // const [ state, dispatch ] = useReducer(AppReducer, debugInitialState);
  const [ state, dispatch ] = useReducer(AppReducer, initialState);

  const NotFound = () => <Redirect to={FIRST_URL} />;

  const routes = [
    { path: INPUT_URL, Component: Input },
    { path: CONF_URL, Component: Conf },
    { path: THANKS_URL, Component: Thanks },
    { path: ADD_INPUT_URL, Component: AddInput },
    { path: ADD_CONF_URL, Component: AddConf },
    { path: ADD_THANKS_URL, Component: AddThanks },
  ];

  const transStyle = {
    atEnter: { right: 0, opacity: 0.5 },
    atLeave: { right: 1000, opacity: 0 },
    atActive: { right: 0, opacity: 1 },
  };
  return (
    <div className="App">
      <AppContext.Provider value={{ state, dispatch }}>
        <Router>
          <AnimatedSwitch
            atEnter={transStyle.atEnter}
            atLeave={transStyle.atLeave}
            atActive={transStyle.atActive}
            className="App-switch-wrapper"
          >
            {routes.map(({ path, Component }) => (
              <Route exact key={path} path={path} component={Component} />
            ))}
            <Route path='/' component={NotFound} />
          </AnimatedSwitch>
        </Router>
      </AppContext.Provider>
    </div>
  );
};

export default App;
